<template>
  <div class="col-md-8 col-xs-12 col-sm-12 col-12 login-footer">
    <hr />
    <p class="small-text">
      {{ sign }} © Copyright {{ new Date().getFullYear() }}. {{ $t('m164') }}
      <br />
      <template v-if="$store.getters['visualResources/appName'] === 'Awto'">
        <a-link
          href="https://www.awtosuite.pro/appresources/termsandconditions"
        >
          {{ $t('m14') }}
        </a-link>
        ·
        <a-link
          href="https://www.awtosuite.pro/appresources/termsandconditions#heading_anex6"
        >
          {{ $t('termsOfUse') }}
        </a-link>
        ·
        <a-link href="https://gowgo.awto.cl/awto/faq"> FAQ </a-link>
        ·
        <a-link href="https://awto.cl/contacto/"> {{ $t('contact') }} </a-link>
      </template>
    </p>
  </div>
</template>

<script>
import ALink from '@/components/ui/ALink';

export default {
  components: {
    ALink,
  },
  computed: {
    sign() {
      if (this.$store.getters['visualResources/appName'] !== 'Awto') {
        return `${this.$store.getters['visualResources/appName']} powered by Awto`;
      }
      return this.$store.getters['visualResources/appName'];
    },
  },
};
</script>
